/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountPassword.defs'
export { main as default } from './updateAccountPassword.defs'
